export default __webpack_public_path__ + "static/media/DSC_7653.59c36009.jpg";